import React from "react";
import {
  Image,
  StyleProp,
  StyleSheet,
  TextInput,
  View,
  ViewStyle,
} from "react-native";
import {
  color_333333,
  color_BEBEBE,
  ColorGrey,
  ColorLine,
  white,
} from "../assets/style/colors";
import { Str_NoSpacesAllowed, Str_Search } from "../language/string_res";
import { ImageView } from "./ImageView";
import { showToast } from "./Toast";

interface CSearchInputProps {
  placeholder?: string;
  searchVal: string;
  onChange: (val: string) => void;
  onClean?: () => void;
  style?: StyleProp<ViewStyle>;
  searchContainerStyle?: StyleProp<ViewStyle>;
}

export const CSearchInput = ({
  placeholder,
  searchVal,
  onChange,
  onClean,
  style,
  searchContainerStyle,
}: CSearchInputProps) => {
  return (
    <View style={[styles.container, styles.dflex, style]}>
      <View
        style={[styles.searchContainer, styles.dflex, searchContainerStyle]}
      >
        <Image
          source={require("../assets/image/icon_search.png")}
          width={30}
          height={30}
        />
        <TextInput
          autoCapitalize="none"
          style={styles.inputContainer}
          placeholder={placeholder || Str_Search}
          placeholderTextColor={color_BEBEBE}
          value={searchVal}
          onChangeText={(text) => {
            if (text.includes(" ")) {
              showToast(Str_NoSpacesAllowed);
              text = text.trim();
            }
            onChange(text);
          }}
          blurOnSubmit={false}
        />
        {onClean && searchVal && searchVal?.length > 0 && (
          <ImageView
            onClick={onClean}
            source={require("../assets/image/icon_del.png")}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  dflex: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  container: {
    backgroundColor: white,
    height: 60,
    // borderBottomWidth: 1,
    // borderBottomColor: ColorLine,
  },
  searchContainer: {
    flex: 1,
    marginHorizontal: 12,
    height: 40,
    backgroundColor: ColorGrey,
    borderRadius: 10,
    paddingHorizontal: 12,
  },
  inputContainer: {
    flex: 1,
    fontSize: 16,
    marginLeft: 5,
    color: color_333333,
  },
});
